<template>
  <div>
    <v-overlay :value="overlay" :z-index="201"></v-overlay>
    <v-progress-linear :active="active" :height="height" color="primary" indeterminate rounded absolute striped></v-progress-linear>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      overlay: false,
    };
  },
  computed: {
    height() {
      return this.dialog ? 3 : 4;
    },
  },
  watch: {
    /*
     * http 요청이 순식간에 끝나는 경우 progress는 눈에 안 보이고
     * overlay만 순간 나타났다 사라져 화면이 깜빡이는 좋지않은 UX가 연출되므로
     * overlay가 나타나는 순간을 50 millis 만큼 늦춤..
     */
    active: {
      immediate: true,
      handler() {
        setTimeout(() => {
          this.overlay = !this.dialog && this.active;
        }, 50);
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
